/** Teal-blue — Button variant="primary", Sidebar default active icon, Topbar assistantPrimary */
export const GRADIENT_PRIMARY_CSS = 'linear-gradient(135deg, #00C2C2 0%, #155DFC 100%)';
export const GRADIENT_PRIMARY_CLASS = 'bg-[linear-gradient(135deg,#00C2C2_0%,#155DFC_100%)]';

/** Purple accent — Badge/SegmentedControl/ViewToggle primary, Sidebar variant="primary" */
export const GRADIENT_PURPLE_CSS = 'linear-gradient(135deg, #7c5cfc 0%, #5b8def 100%)';
export const GRADIENT_PURPLE_CLASS =
  'bg-[linear-gradient(135deg,#7c5cfc_0%,#5b8def_100%)]';

/** Button variant="gradient" — Topbar assistant (default) */
export const GRADIENT_BUTTON_GRADIENT_CLASS =
  'bg-[radial-gradient(101.53%_168%_at_50.65%_10%,#2173FF_29.05%,#09E2AB_80%)]';

export const GRADIENT_BUTTON_GRADIENT_HOVER_CLASS =
  'hover:bg-[radial-gradient(101.53%_168%_at_50.65%_10%,#002F80_29.05%,#09E2AB_80%)]';

export const GRADIENT_BUTTON_GRADIENT_SHADOW_CLASS =
  'shadow-[4px_8px_24px_8px_rgba(9,226,171,0.16)]';
